import { useCallback, useEffect, useRef, useState } from "react";

export const useScrollDirection = (threshold = 10) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAtTop, setIsAtTop] = useState(true);
  const lastScrollY = useRef(0);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    const isNearTop = currentScrollY < threshold;

    setIsAtTop(isNearTop);

    if (isNearTop) {
      setIsVisible(true);
    } else {
      setIsVisible(currentScrollY < lastScrollY.current);
    }

    lastScrollY.current = currentScrollY;
  }, [threshold]);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return { isVisible, isAtTop };
};
